import { render, staticRenderFns } from "./ownerMembers.vue?vue&type=template&id=2c5ed2c1&scoped=true"
import script from "./ownerMembers.vue?vue&type=script&lang=js"
export * from "./ownerMembers.vue?vue&type=script&lang=js"
import style0 from "./ownerMembers.vue?vue&type=style&index=0&id=2c5ed2c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ed2c1",
  null
  
)

export default component.exports